export default {
  promo: {
    metrics: {
      description_1: 'Recommendation effectiveness',
      description_2: 'Architecture speed',
      description_3: 'Visualization depth'
    }
  }
}